import { format } from "date-fns";
import { useEffect, useState } from "react";
import { BsPlayBtnFill } from "react-icons/bs";
import { FaFilePdf } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import { LuEye } from "react-icons/lu";
import { MdAutoDelete, MdDelete, MdInfo } from "react-icons/md";
import { PiListChecksFill } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import Button from "../../../Components/Button/index.jsx";
import CardProgressao from "../../../Components/ProgressaoParcial/CardAddEditProgressao/index.jsx";
import CardGerarResultadoProgressao from "../../../Components/ProgressaoParcial/CardGerarResultProgre/index.jsx";
import CardListarAlunosPP from "../../../Components/ProgressaoParcial/CardListarAlunosPP/index.jsx";
import CardVerInformacoes from "../../../Components/ProgressaoParcial/CardVerInformacoes/index.jsx";
import CardVerPdfProgressao from "../../../Components/ProgressaoParcial/CardVerPdfProgressao/index.jsx";
import VerDocExemplar from "../../../Components/ProgressaoParcial/InsirirDocExemplar/index.jsx";
import api from "../../../Services/api.js";
import { Alert } from "../../../utils/Alert.js";
import Loading from "../../../utils/Loading";
import { Description2 } from "../Coordenador/styles.js";
import {
  Buttons,
  ContainerTable,
  Description,
  DivMain,
  DivText,
  Menus,
  Page,
  Table,
  Tbody,
  Td,
  TdDisciplina,
  Th,
  Theader,
  Title,
  Trbody,
} from "./styles";

export const ProgressaoParcialProfessor = () => {
  const Navigate = useNavigate();
  const [progressaoEdit, setProgressaoEdit] = useState([]);
  const [showAdicionar, setShowAdicionar] = useState(false);
  const [showResultado, setShowResultado] = useState(false);
  const [showEditar, setShowEditar] = useState(false);
  const [deletandoId, setDeletandoId] = useState(null);
  const [progressoes, setProgressoes] = useState([]);
  const [pdfResultado, setPdfResultado] = useState(false);
  const [showPdfProgressao, setShowPdfProgressao] = useState(false);
  const [showMostrarAlunos, setShowMostrarAlunos] = useState(false);
  const [showConfirmarDelete, setShowConfirmarDelete] = useState(false);
  const [progressaoDelete, setProgressaoDelete] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showAddExemplar, setShowAddExemplar] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [pc, setPc] = useState(window.innerWidth > 1000);

  useEffect(() => {
    const handleResize = () => {
      setPc(window.innerWidth > 1000);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setLoading(true);
    ListarProgressoes();
  }, []);
  useEffect(() => {
    ListarProgressoes();
  }, [showAdicionar, showResultado, showEditar, deletandoId, showPdfProgressao, showMostrarAlunos]);

  const date = new Date();
  const dataStr = date.toLocaleString("pt-BR").split(" ")[0];
  const [dia, mes, ano] = dataStr.split("/");

  async function ListarProgressoes() {
    try {
      const res = await api.get("/professor/listar-progressoes");

      const { progressoes, progressoesComPendencias } = res.data;

      const progressoesAtualizadas = progressoes.map((p) => {
        if (progressoesComPendencias?.includes(p.id)) {
          return { ...p, emAvaliacao: true };
        }
        return { ...p, emAvaliacao: false };
      });

      setProgressoes(progressoesAtualizadas);
      // console.log(progressoesAtualizadas);
    } catch (err) {
      setProgressoes([]);
      console.clear();
    } finally {
      setLoading(false);
    }
  }

  async function DeletarProgressoes(id, pdf, andamento, terminou) {
    if (andamento) {
      return Alert({ tipo: "Alert3", mensagem: "Está progressão já começou. Nâo é possível deleta-lá!" });
    } else if (terminou) {
      return Alert({ tipo: "Alert3", mensagem: "Está progressão já terminou. Nâo é possível deleta-lá" });
    } else {
      const result = await Alert({ tipo: "Alert", mensagem: "Deseja deletar essa progressão?" });
      if (result.isConfirmed) {
        setDeletandoId(id);
        try {
          await api
            .delete(`/professor/deletar-progressao`, {
              params: { id, pdf },
            })
            .then(async (response) => {
              await Alert({
                tipo: "Sucesso3",
                mensagem: `${response.data.mensagem ? response.data.mensagem : "Progressão deletada com sucesso"}`,
              });
              return ListarProgressoes();
            })
            .catch((erro) => {
              Alert({
                tipo: "Erro2",
                mensagem: `${erro.response.data.erro ? erro.response.data.erro : "Erro ao deletar a progressão"}`,
              });
              setDeletandoId(null);
            });
        } catch (err) {
          console.log("Erro: ", err);
          setDeletandoId(null);
        }
      }
    }
  }

  function ConfirmarExclusaoComAlunos(dadosProgressao, andamento, terminou) {
    if (andamento) {
      return Alert({ tipo: "Alert3", mensagem: "Está progressão já começou. Nâo é possível deleta-lá!" });
    }

    if (terminou) {
      return Alert({ tipo: "Alert3", mensagem: "Está progressão já terminou. Nâo é possível deleta-lá" });
    }

    setProgressaoDelete(dadosProgressao);
    setShowConfirmarDelete(true);
  }

  const Thead = () => (
    <Theader>
      <tr>
        <Th title="Professor">Professor</Th>
        <Th title="Curso">Curso</Th>
        <Th title="Turma">Turma</Th>
        <Th title="Disciplina">Disciplina</Th>
        <Th title="Início">Início</Th>
        <Th title="Limite Entrega">Limite Entrega</Th>
        <Th title="Avaliar">Avaliar</Th>
        <Th title="Ver Alunos">Ver Alunos</Th>
        <Th title="PDF">PDF</Th>
        <Th title="Informações">Informações</Th>
        <Th title="Editar">Editar</Th>
        <Th title="Deletar">Deletar</Th>
      </tr>
    </Theader>
  );

  return (
    <Page>
      <DivMain>
        <Menus>
          <Title>Turmas Progressão Parcial</Title>
          <Buttons>
            <Button
              event={() => {
                Navigate("/Professor");
              }}
              width={pc ? "8rem" : ""}
              margintop={pc ? "1%" : "1rem"}
              placeholder="Voltar"
              backgroundcolor="#1a2e35"
              borderRadius="30px 30px 0px 0px"
            />
            <Button
              event={() => setShowAdicionar(true)}
              width={pc ? "10rem" : ""}
              margintop={pc ? "1%" : "1rem"}
              backgroundcolor="#1a2e35"
              placeholder="Adicionar"
              borderRadius="30px 30px 0px 0px"
            />
          </Buttons>
          <Description2 onClick={() => setShowAddExemplar(true)}>
            <BsPlayBtnFill color="red" size={36} /> Visão geral <br />
            Progressão
          </Description2>
          {progressoes.length ? (
            <>
              <Description>
                <p>
                  <span className="agendada" />
                  Agendadas
                </p>
                <p>
                  <span className="andamento" />
                  Em Andamento
                </p>
                <p>
                  <span className="emAvaliacao" />
                  Em avaliação
                </p>
                <p>
                  <span className="terminou" />
                  Encerradas
                </p>
              </Description>
            </>
          ) : null}
        </Menus>
        {loading ? (
          <ContainerTable $loading={loading}>
            <Loading />
          </ContainerTable>
        ) : (
          <ContainerTable>
            {progressoes.length ? (
              <Table>
                {Thead()}
                <Tbody>
                  {progressoes?.map((d, i) => {
                    //console.log(d);

                    const dataAtual = new Date();
                    const dataInicio = new Date(d.data_inicio);
                    const dataFim = new Date(d.data_fim);
                    const andamento = dataAtual >= dataInicio && dataAtual <= dataFim;
                    const terminou = dataAtual > dataFim;
                    const agendada = dataInicio > dataAtual;

                    // Adiciona 15 dias à data de fim
                    const dataFimMais15Dias = new Date(dataFim);
                    dataFimMais15Dias.setDate(dataFimMais15Dias.getDate() + 15);
                    // Verifica se a data atual é maior que a data de fim + 15 dias
                    //const MaisDe15Dias = dataAtual > dataFimMais15Dias;
                    const emAvaliacao = terminou && d?.emAvaliacao;
                    const encerrada = terminou && !d?.emAvaliacao;

                    const turma = d.turma_rh
                      ? d.turma_rh.split(",")[1]?.trim()?.split("-")?.slice(1)?.join(" - ")
                      : "Sem turma";

                    const curso = d.curso_rh
                      ? d.curso_rh.split(",")[1]
                        .replace(/(TÉCNICO EM|TECNÓLOGO EM)/g, "")
                        .trim()
                      : "Sem curso";


                    const professor =
                      typeof d?.professor === "string"
                        ? d.professor.includes(",")
                          ? d.professor.split(",")[1]?.trim()?.split(" ")?.slice(0, 2)?.join(" ")
                          : d.professor.split(" ")?.slice(0, 2)?.join(" ")
                        : "Professor inválido";

                    return (
                      <Trbody key={i}>
                        <Td title={professor}>
                          {emAvaliacao ? (
                            <p>
                              <span className="emAvaliacao" />
                              {professor}
                            </p>
                          ) : encerrada ? (
                            <p>
                              <span className="terminou" />
                              {professor}
                            </p>
                          ) : andamento ? (
                            <p>
                              <span className="andamento" />
                              {professor}
                            </p>
                          ) : agendada ? (
                            <p>
                              <span className="agendada" />
                              {professor}
                            </p>
                          ) : (
                            <p>{professor}</p>
                          )}
                        </Td>
                        <Td title={typeof d?.curso_rh === "string" ? curso : "Curso inválido"}>
                          {typeof d?.curso_rh === "string" ? curso : "Curso inválido"}
                        </Td>
                        <Td title={typeof d?.turma_rh === "string" ? turma : "Turma inválida"} className="turma">
                          {typeof d?.turma_rh === "string" ? turma : "Turma inválida"}
                        </Td>
                        <TdDisciplina
                          title={
                            typeof d?.disciplina_rh === "string" ? d.disciplina_rh.split(",")[1] : "Disciplina inválida"
                          }
                        >
                          {typeof d?.disciplina_rh === "string" ? d.disciplina_rh.split(",")[1] : "Disciplina inválida"}
                        </TdDisciplina>
                        <Td title={d?.data_inicio ? format(dataInicio, "dd/MM/yyyy") : "Data inválida"}>
                          {d?.data_inicio ? format(dataInicio, "dd/MM/yyyy") : "Data inválida"}
                        </Td>
                        <Td title={d?.data_fim ? format(dataFim, "dd/MM/yyyy") : "Data inválida"} className="icon">
                          {d?.data_fim ? format(dataFim, "dd/MM/yyyy") : "Data inválida"}
                        </Td>
                        <Td className="icon">
                          <PiListChecksFill
                            onClick={() => {
                              if (terminou) {
                                setShowResultado(!showResultado);
                                setProgressaoEdit(d);
                              } else {
                                Alert({
                                  tipo: "Alert2",
                                  mensagem: `Avaliar somente após o Encerramento: ${format(dataFim, "dd/MM/yyyy")}`,
                                });
                              }
                            }}
                            size={"2rem"}
                            cursor={"pointer"}
                            title={
                              terminou ? "Inserir Resultado" : `Após o Encerramento: ${format(dataFim, "dd/MM/yyyy")}`
                            }
                            color={terminou ? "#000" : "#535353"}
                          />
                        </Td>
                        <Td className="icon">
                          <LuEye
                            onClick={() => {
                              setShowMostrarAlunos(true);
                              setProgressaoEdit(d);
                            }}
                            size={"2rem"}
                            cursor={"pointer"}
                            title="Ver Alunos"
                          />
                        </Td>
                        <Td className="icon">
                          <FaFilePdf
                            onClick={() => {
                              if (!d?.pdf) return Alert({ tipo: "Alert3", mensagem: "Não há pdf disponível!" });
                              else return (setShowPdfProgressao(true), setProgressaoEdit(d));
                            }}
                            size={"1.8rem"}
                            cursor={"pointer"}
                            title="Ver PDF"
                            color={d?.pdf ? "#de000e" : "#535353"}
                          />
                        </Td>

                        <Td className="icon">
                          <MdInfo
                            onClick={() => {
                              setShowForm(true);
                              setProgressaoEdit(d);
                            }}
                            size={"1.8rem"}
                            cursor={"pointer"}
                            title={"informações"}
                            color={"#00a2ff"}
                          />
                        </Td>
                        <Td className="icon">
                          <FiEdit
                            onClick={() => {
                              // if (terminou)
                              //   return Alert({
                              //     tipo: "Alert3",
                              //     mensagem: `Esta progressão terminou. Não é possível editá-la!`,
                              //   });
                              // else {
                              //   // setShowEditar(true), setProgressaoEdit(d);
                              // }
                              return Alert({
                                tipo: "Alert3",
                                mensagem: `Não é possível editá-la!`,
                              });
                            }}
                            size={"2rem"}
                            color={
                              // terminou ? "#00000045" : "#000"
                              "#00000045"
                            }
                            cursor={
                              // terminou ? "not-allowed" : "pointer"
                              "not-allowed"
                            }
                            title="Editar"
                          />
                        </Td>
                        <Td className="icon">
                          {deletandoId !== d?.id ? (
                            <MdDelete
                              onClick={() => {
                                // ConfirmarExclusaoComAlunos(d, andamento, terminou);
                                return Alert({
                                  tipo: "Alert3",
                                  mensagem: `Nâo é possível deleta-lá!`,
                                });
                              }}
                              size={"2rem"}
                              color={
                                // andamento || terminou ? "#00000045" : "#000"
                                "#00000045"
                              }
                              cursor={
                                // andamento || terminou ? "not-allowed" : "pointer"
                                "not-allowed"
                              }
                              title="Deletar"
                            />
                          ) : (
                            <MdAutoDelete size={"2rem"} cursor={"pointer"} title="Deletando" />
                          )}
                        </Td>
                      </Trbody>
                    );
                  })}
                </Tbody>
              </Table>
            ) : (
              <>
                <Table> {Thead()}</Table>
                <DivText>Nenhuma Progressão Adicionada</DivText>
              </>
            )}
          </ContainerTable>
        )}
      </DivMain>
      {/* Para adicionar uma nova progressão*/}
      <CardProgressao show={showAdicionar} setShow={setShowAdicionar} mode="add" />
      {/* Para editar uma progressão existente*/}
      <CardProgressao show={showEditar} setShow={setShowEditar} mode="edit" progressaoEdit={progressaoEdit} />
      {/* Para ver e gerar o resultado da progressão*/}
      <CardGerarResultadoProgressao show={showResultado} setShow={setShowResultado} progressaoEdit={progressaoEdit} />
      {/* Para ver o pdf da progressão*/}
      <CardVerPdfProgressao Show={showPdfProgressao} setShow={setShowPdfProgressao} progressaoEdit={progressaoEdit} />
      {/* Para ver os alunos da progressão*/}
      <CardListarAlunosPP
        MostrarAlunos={showMostrarAlunos}
        setMostrarAlunos={setShowMostrarAlunos}
        progressaoEdit={progressaoEdit}
      />
      {/* Para confirmar exclusão mostrando alunos da progressão*/}
      <CardListarAlunosPP
        MostrarAlunos={showConfirmarDelete}
        setMostrarAlunos={(show) => {
          setShowConfirmarDelete(show);
          if (!show) setProgressaoDelete(null);
        }}
        progressaoEdit={progressaoDelete || {}}
        modoExclusao={true}
        deletando={deletandoId === progressaoDelete?.id}
        onConfirmarExclusao={() => DeletarProgressoes(progressaoDelete?.id, progressaoDelete?.pdf, false, false)}
      />
      {/* Para ver o(s) documento(s) exemplar(es)*/}
      <VerDocExemplar show={showAddExemplar} setShow={setShowAddExemplar} perfil={"prof"} />

      <CardVerInformacoes show={showForm} setShow={setShowForm} progressaoEdit={progressaoEdit} />
    </Page>
  );
};
